/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetGooseGameQuestLogsQueryVariables = Types.Exact<{
  event_attendee_id: Types.Scalars["Float"];
}>;

export type GetGooseGameQuestLogsQuery = {
  gooseGameQuestLogs: Array<
    Pick<
      Types.GooseGameQuestLog,
      "id" | "quest_id" | "created_at" | "event_attendee_id"
    >
  >;
};

export const GetGooseGameQuestLogsDocument = gql`
  query GetGooseGameQuestLogs($event_attendee_id: Float!) {
    gooseGameQuestLogs(event_attendee_id: $event_attendee_id) {
      id
      quest_id
      created_at
      event_attendee_id
    }
  }
`;

/**
 * __useGetGooseGameQuestLogsQuery__
 *
 * To run a query within a React component, call `useGetGooseGameQuestLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGooseGameQuestLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGooseGameQuestLogsQuery({
 *   variables: {
 *      event_attendee_id: // value for 'event_attendee_id'
 *   },
 * });
 */
export function useGetGooseGameQuestLogsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetGooseGameQuestLogsQuery,
    GetGooseGameQuestLogsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetGooseGameQuestLogsQuery,
    GetGooseGameQuestLogsQueryVariables
  >(GetGooseGameQuestLogsDocument, baseOptions);
}
export function useGetGooseGameQuestLogsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetGooseGameQuestLogsQuery,
    GetGooseGameQuestLogsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetGooseGameQuestLogsQuery,
    GetGooseGameQuestLogsQueryVariables
  >(GetGooseGameQuestLogsDocument, baseOptions);
}
export type GetGooseGameQuestLogsQueryHookResult = ReturnType<
  typeof useGetGooseGameQuestLogsQuery
>;
export type GetGooseGameQuestLogsLazyQueryHookResult = ReturnType<
  typeof useGetGooseGameQuestLogsLazyQuery
>;
export type GetGooseGameQuestLogsQueryResult = ApolloReactCommon.QueryResult<
  GetGooseGameQuestLogsQuery,
  GetGooseGameQuestLogsQueryVariables
>;
